import { deburr as _ } from 'lodash';

const CHANGE_CHARACTERS = {
    from: 'ęóąśłżźćńĘÓĄŚŁŻŹĆŃ'.split(''),
    to: 'eoaslzzcnEOASLZZCN'.split('')
};

export default function deburr(str) {
    str = _(str);

    for (let i = CHANGE_CHARACTERS.from.length - 1; i >= 0; i--) {
        str = str.split(CHANGE_CHARACTERS.from[i]).join(CHANGE_CHARACTERS.to[i]);
    }

    return str;
}
